import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Region } from '../models/region.interface';

@Injectable({
  providedIn: 'root',
})
export class RegionBackendService {
  public crId: string = '65e835df-66db-40cf-8e98-257e85493f89';
  private readonly baseUrl = 'https://regionsapi.crbytes.app';
  private readonly apiKey = '879ef457d0814431b7424c87e14f461c';

  constructor(private readonly _http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'x-crbytes-key': this.apiKey
    });
  }

  private buildUri(endpoint: string): string {
    return `${this.baseUrl}/${endpoint}`;
  } // buildUri

  public getSubregions(regionId: string): Observable<Region[]> {
    const endpoint = this.buildUri(`api/subRegions/${regionId}`);
    return this._http.get<Region[]>(endpoint, { headers: this.getHeaders() });
  }// getAll

  public getRegionHierarchy(regionId: string): Observable<any> {
    const endpoint = this.buildUri(`api/regionHierarchy/${regionId}`);
    return this._http.get<any>(endpoint, { headers: this.getHeaders() });
  }

  public getRootRegionByISO2(iso2: string): Observable<Region> {
    const endpoint = this.buildUri(`api/byISO2/${iso2.toLowerCase()}`);
    return this._http.get<Region>(endpoint, { headers: this.getHeaders() });
  }
}
